"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnonymousStorageGet = useAnonymousStorageGet;
const swr_1 = __importDefault(require("swr"));
const utils_1 = require("../utils");
const useAnonymousClient_1 = require("./useAnonymousClient");
/**
 * Calls `anonymousClient.storageGet` and returns an SWR response. SWR `revalidateOnFocus` option is set to `false`.
 *
 * @param entity - entity name
 * @param id - id to pass to `anonymousClient.storageGet`, this is optional, if not set backend will not be called and result will not be returned
 * @param appName - optional appName, if not set `window.appName` will be used
 * @param config - custom SWR configuration object
 */
function useAnonymousStorageGet(entity, id, appName, config) {
    const resolvedAppName = (0, utils_1.getAppName)(appName);
    const storage = (0, useAnonymousClient_1.useAnonymousClient)(resolvedAppName, entity);
    return (0, swr_1.default)(id ? [`/platform/anonymous/storage/${entity}/get`, id] : null, async ([, id]) => {
        return id ? storage.storageGet(id) : undefined;
    }, config ?? {
        revalidateOnFocus: false,
    });
}
